import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqData = [
  {
    q: "Hva er Trysil?",
    a: "LYKKE TRYSIL er en stor badstue uten forhall, designet for 8 personer. Hele 440 × 240 cm er dedikert til komfortabel badstuopplevelse på to nivåer."
  },
  {
    q: "Hva er inkludert i standardprisen?",
    a: "HUUM Hive Mini 10 kW ovn, Aspetre STS4 panel, LED-belysning, varmebehandlet tregulv, hertet glass dør, multi-nivå hengende benker, og LYKKE löyly pakke."
  },
  {
    q: "Kan jeg tilpasse farger og materialer?",
    a: "Ja, TRYSIL kan tilpasses med alternative paneler, utvendig kledning, glassbehandlinger, ovner, og belysning. Se tilleggsalternativer i konfiguratoren."
  },
  {
    q: "Hva er leveringstiden?",
    a: "Standard leveringstid er 6–8 uker fra ordrebekreftelse."
  },
  {
    q: "Hvor mange personer passer i TRYSIL?",
    a: "TRYSIL er designet for 8 personer. Romslig innvendig volum med komfortable benker på flere nivåer."
  },
  {
    q: "Kan TRYSIL brukes hele året?",
    a: "Ja, TRYSIL er designet for helårsbruk. Du kan oppgradere til varmeledende gulv for optimal komfort på vinterdag."
  }
];

export default function TrysilFaqAccordion() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <div className="space-y-3">
      {faqData.map((item, i) => (
        <button
          key={i}
          onClick={() => setOpenIdx(openIdx === i ? null : i)}
          className="w-full text-left border border-foreground/10 p-5 hover:bg-foreground/2 transition-colors rounded-sm"
        >
          <div className="flex items-center justify-between">
             <h3 className="font-body text-2xl font-medium text-foreground">{item.q}</h3>
             <motion.div animate={{ rotate: openIdx === i ? 180 : 0 }} transition={{ duration: 0.2 }}>
               <ChevronDown size={18} className="text-foreground/40" />
             </motion.div>
           </div>
           <AnimatePresence>
             {openIdx === i && (
               <motion.div
                 initial={{ opacity: 0, height: 0 }}
                 animate={{ opacity: 1, height: "auto" }}
                 exit={{ opacity: 0, height: 0 }}
                 transition={{ duration: 0.2 }}
                 className="overflow-hidden"
               >
                 <p className="text-foreground/60 text-2xl leading-relaxed mt-4 font-body">{item.a}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </button>
      ))}
    </div>
  );
}